import featureFlags from '@masfront/common-feature-flags'
import axios from 'axios'
import qs from 'query-string'

import { appDeps } from '~/appCore'
import { isDevOrLocalOrTest } from '~/config/helpers'

/* eslint-disable camelcase */
export interface Token {
  access_token: string
  expires_in: number
  refresh_token: string
  token_type: string
}

const NO_TOKEN_MOCK: Token = {
  access_token: 'NO_TOKEN_MOCK',
  expires_in: 3600,
  refresh_token: 'NO_TOKEN_MOCK',
  token_type: 'Bearer',
}

const FAKE_ACCESS_TOKEN: Token = {
  access_token: 'FAKE_ACCESS_TOKEN',
  expires_in: 3600,
  refresh_token: 'FAKE_REFRESH_TOKEN',
  token_type: 'Bearer',
}

export function getToken(): Promise<Token> {
  const flags = featureFlags.getFlags()

  if (isDevOrLocalOrTest(appDeps.runtimeConfig.environment)) {
    return Promise.resolve(flags.isLoginActive ? NO_TOKEN_MOCK : FAKE_ACCESS_TOKEN)
  }

  if (flags.isLoginActive) {
    return Promise.resolve(NO_TOKEN_MOCK)
  }

  return axios
    .post(
      'https://authn.sta.k8s.masmovil.com/oauth/token',
      qs.stringify({
        username: '693703984',
        password: 'UJ9TB39',
        grant_type: 'password',
      }),
      {
        headers: {
          authorization:
            'Basic Y1AyQ2ZGMEJPdFNUU3RQSlFwQXY6bVJNZ3U0dW10QVQyemJaWm1TbVZBWlhOOFA1RTFTUjdLcExoMGhHNkw1TSUzRA==',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
    .then((resp) => resp.data)
}
